import type { QueryClient } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';

import { setQueryPosition } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

export const invalidateAdvisorServiceQueries = async (
    queryClient: QueryClient,
    loanRequestId: string,
    position?: number,
) => {
    if (position !== undefined) {
        setQueryPosition(JSON.stringify(queryKeys.find()), position);
        setQueryPosition(JSON.stringify(queryKeys.get(loanRequestId)), position);
    }

    await Promise.all([
        queryClient.invalidateQueries({ exact: false, queryKey: [AGGREGATE_NAMES.LOAN_REQUEST, 'getSummary'] }),
        queryClient.invalidateQueries({ exact: false, queryKey: [AGGREGATE_NAMES.LOAN_REQUEST, 'getCounts'] }),
        queryClient.invalidateQueries({ queryKey: queryKeys.get(loanRequestId) }),
        queryClient.invalidateQueries({
            exact: false,
            queryKey: [AGGREGATE_NAMES.LOAN_REQUEST, LOAN_REQUEST_RESOLVERS.getAddedAssignedUserLeads],
        }),
        // the share changes who may reassign, add or end it
        queryClient.invalidateQueries({ exact: false, queryKey: queryKeys.getAclPermissions({ loanRequestId }) }),
    ]);
};
